import { Component, OnInit } from '@angular/core';
import { StudyState, AreaFocus } from '../../../models';
import { Router } from '@angular/router';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { ILevel } from 'app/interfaces';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { stateConstant } from '../../../../constants';
import { stringUtility } from '../../../../utils/stringUtility';

declare var $: any;

@Component({
  selector: 'education',
  templateUrl: 'education.component.html'
})

export class EducationComponent implements OnInit {
  levels: ILevel[];
  formClass: string = "";
  errormsg: any[] = new Array();
  errdisplay: boolean = false;
  states: any[] = stateConstant;
  trackingName = "Education";
  stringUtil = new stringUtility();

  constructor(private _services: ServiceInterface, public _parent: PworkflowComponent, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  async ngOnInit() {
    if(this._parent.campaignName){
      this.trackingName = this._parent.campaignName+" - Education";
    }
  
    if (this._parent.collegeDetails) {
      let state = this.states.find(state => state.value == this._parent.collegeDetails.state);
      if (!this._parent.model.study_state.find(statedata => statedata.name == state.name)) {
        this._parent.model.study_state.push(state);
      }
    }
    this.settypeahead(this.states);
    this.levels = await this._services.getList('/levels');
    this.stringUtil.mergeStringContainFromArray(this.levels,'certificate','Certificates');
  }
  
  settypeahead(source) {
    var thisel = this;
    $("#study-state").typeahead({
      minLength: 0,
      delay: 100,
      autoSelect: true,
      items: 'all',
      source: source,
      displayText: function (item) { return item.name; },
      afterSelect: function (item) {
        let csitem = new StudyState();
        if (thisel._parent.model.study_state.length < 5) {
          if (thisel._parent.model.study_state.findIndex(x => x.value.toLowerCase() == item.value.toLowerCase()) < 0) {
            csitem.name = item.name;
            csitem.value = item.value;
            thisel._parent.model.study_state.push(csitem);
          }
        } else {
          alert("You cannot choose more than 5 states");
        }
        $("#study-state").val("");
      }
    });
  }

  loadStudystate() {
    this._parent.model.study_state_value = " ";
    $("#study-state").typeahead('lookup');
    this._parent.model.study_state_value = "";
  }

  deleteStudystate(val) {
    for (var index = 0; index < this._parent.model.study_state.length; index++) {
      if (this._parent.model.study_state[index]["value"].toLowerCase() == val.toLowerCase()) {
        this._parent.model.study_state.splice(index, 1);
      }
    }
  }

  async changeEducationgoal(id) {
    this._parent.model.education_goal = id;
    var sel = "0";
    if (this._parent.model.education_goal != "") {
      sel = this._parent.model.education_goal;
    }

    /*this._parent.model.primary_bucket = new Array<AreaFocus>();
    this._parent.model.bucket_id = "";

    this._parent.model.secondary_bucket = new Array<AreaFocus>();
    this._parent.model.secondary_bucket_value = "";
    this._parent.model.secondary_bucket_ids = "";*/
    /*if (sel == "0" || sel == "") {
      this.secondaryBucketList = await this._services.getList('/secondarybucketlist');
      $("#secondary_bucket").data('typeahead').source = this.secondaryBucketList;
      return false;
    }
    this.secondaryBucketList = await this._services.getList('/secondarybucketlist/' + bid);
    $("#secondary_bucket").data('typeahead').source = this.secondaryBucketList;*/
  }

  checkRadioButton(id) {
    if(this._parent.model.education_goal == id) {
      document.getElementById('mark-error').className = 'radio-choice mt-2 mb-0'
      return true;
    } else {
      return false;
    }
  }

  clickSubmit(valid) {
    this.errormsg = [];
    if (valid) {
      if (this._parent.model.education_goal == "") {
        document.getElementById('mark-error').className = 'error-check mt-2 mb-0'
        // document. = "checkmark ng-invalid2"
        this.errdisplay = true;
        this.errormsg.push("Please enter education goal.");
      } else {
        this.educationsubmit();
      }
    } else {
      if (this._parent.model.education_goal == "") {
        document.getElementById('mark-error').className = 'error-check mt-2 mb-0'
        // document. = "checkmark ng-invalid2"
        this.errdisplay = true;
        this.errormsg.push("Please enter education goal.");
      }
      if (this._parent.model.study_state.length == 0) {
        this.errdisplay = true;
        this.errormsg.push("Please enter study state.");
      }
      this.formClass = "validate";
    }
  }

  async educationsubmit() {
    if (this._parent.model.study_state.length > 0) {
      this._parent.model.study_state_values = this._parent.model.study_state.map(a => a.value).join(',');
      //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 1);
      this._parent.index++;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/education/education.component.ts